export interface RuntimeConfig {
  [key: string]: string | undefined;
}

declare global {
  interface Window {
    RUNTIME_CONFIG?: RuntimeConfig;
  }
}

const runtimeConfig: RuntimeConfig =
  typeof window !== 'undefined' && window.RUNTIME_CONFIG ? window.RUNTIME_CONFIG : {};

export const getConfigVar = (key: string, fallback?: string): string | undefined => {
  // Prefer runtime value injected by the server via window.RUNTIME_CONFIG
  // (lets one Docker image deploy to test vs prod with different config).
  const runtimeVal = runtimeConfig[key];
  if (runtimeVal !== undefined) return runtimeVal;
  // Fallback to build-time env. Vite substitutes `process.env` with a
  // literal object containing REACT_APP_* + NODE_ENV at build time (see
  // `define` in vite.config.ts); under Jest / Node this stays as the
  // real process.env. Either way, indexed access works.
  const buildTimeVal =
    typeof process !== 'undefined' ? process.env && (process.env as any)[key] : undefined;
  if (buildTimeVal !== undefined) return buildTimeVal as string;
  return fallback;
};
